import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=087cfc57&scoped=true"
import script from "./workspace.vue?vue&type=script&lang=js"
export * from "./workspace.vue?vue&type=script&lang=js"
import style0 from "./workspace.vue?vue&type=style&index=0&id=087cfc57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087cfc57",
  null
  
)

export default component.exports